module.exports = __webpack_public_path__ + "static/media/UR.4e99070f.svg";